export default __webpack_public_path__ + "static/media/faqIcon.f6355010.svg";